import { Type } from '@angular/core';

export class SideBarLink {
  constructor(
    public level: number,
    public title: string,
    public icon?: string,
    public idTab?: string,
    public url?: string,
    public subTabs?: SideBarLink[],
    public id?: number,
  ) {}
}
